import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, Typography, CircularProgress, Button } from '@mui/material';
import { MdCheckCircle, MdError, MdWarning } from 'react-icons/md';

const ConfirmAccount = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');

    if (!token) {
      setStatus('no-token');
      setMessage('No confirmation token provided.');
      setLoading(false);
      return;
    }

    fetch(`https://wallet.menelik.cc/api/auth/confirm?token=${token}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.message) {
          setStatus('success');
          setMessage(data.message);
          setTimeout(() => navigate('/login'), 3000);
        } else {
          setStatus('error');
          setMessage(data.error);
        }
      })
      .catch((error) => {
        console.error('Error during confirmation:', error);
        setStatus('error');
        setMessage('An error occurred during the confirmation process.');
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  const handleRetry = () => {
    navigate(0);
  };

  const marginTopStyle = { marginTop: '20px' };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Card style={{ maxWidth: 400, padding: '20px', textAlign: 'center' }}>
        <CardContent>
          {loading && <CircularProgress />}
          {!loading && (
            <>
              {status === 'success' && (
                <>
                  <MdCheckCircle style={{ color: 'green', fontSize: '4rem' }} />
                  <Typography variant="h5" style={marginTopStyle}>
                    {message}
                  </Typography>
                  <Typography variant="body2" style={{ marginTop: '10px' }}>
                    Redirecting to login page...
                  </Typography>
                </>
              )}
              {status === 'error' && (
                <>
                  <MdError style={{ color: 'red', fontSize: '4rem' }} />
                  <Typography variant="h5" style={marginTopStyle}>
                    {message}
                  </Typography>
                  <Typography variant="body2" style={{ marginTop: '10px' }}>
                    Please try again later or contact support.
                  </Typography>
                  <Button variant="contained" color="primary" onClick={handleRetry} style={marginTopStyle}>
                    Retry
                  </Button>
                </>
              )}
              {status === 'no-token' && (
                <>
                  <MdWarning style={{ color: 'orange', fontSize: '4rem' }} />
                  <Typography variant="h5" style={marginTopStyle}>
                    {message}
                  </Typography>
                  <Typography variant="body2" style={{ marginTop: '10px' }}>
                    Make sure to use the correct confirmation link.
                  </Typography>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => navigate('/')}
                    style={marginTopStyle}
                  >
                    Go to Home
                  </Button>
                </>
              )}
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ConfirmAccount;
